// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUserOutlinedSvg from "@fishx/icons-svg/es/asn/PUserOutlined";
import FishxIcon from '../components/FishxIcon';

var PUserOutlined = function PUserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUserOutlinedSvg
  }));
};

PUserOutlined.displayName = 'PUserOutlined';
export default React.forwardRef(PUserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUserOutlined.js
// module id = 3718
// module chunks = 0